import {APP_INITIALIZER, ApplicationConfig, Injector, PLATFORM_ID, provideZoneChangeDetection} from '@angular/core';
import {provideRouter, withInMemoryScrolling} from '@angular/router';

import {routes} from './app.routes';
import {provideClientHydration, withHttpTransferCacheOptions} from '@angular/platform-browser';
import {provideHttpClient, withFetch, withInterceptors} from '@angular/common/http';
import {httpInterceptor} from './core/interceptors/http.interceptor';
import {AuthService} from '@coreApiServices';
import {isPlatformBrowser} from '@angular/common';
import {firstValueFrom} from 'rxjs';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {provideToastr} from 'ngx-toastr';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes, withInMemoryScrolling({
      // scrollPositionRestoration: 'enabled',
      // anchorScrolling: 'enabled'
    })),
    provideClientHydration(
      withHttpTransferCacheOptions({
        includeHeaders: ['X-Pagination-Page-Count', 'X-Pagination-Per-Page', 'X-Pagination-Current-Page', 'X-Pagination-Total-Count']
      })
    ),
    provideHttpClient(withFetch(), withInterceptors([httpInterceptor])),
    {
      // Rebuild auth state from the HttpOnly cookie via /me before the app renders (browser only).
      // Inject AuthService lazily and only in the browser: depending on it directly would force its
      // whole dependency tree to be constructed during prerender/SSR, where some deps touch `document`.
      provide: APP_INITIALIZER,
      useFactory: (platformId: Object, injector: Injector) => () => {
        if (!isPlatformBrowser(platformId)) {
          return Promise.resolve(null);
        }
        return firstValueFrom(injector.get(AuthService).init());
      },
      deps: [PLATFORM_ID, Injector],
      multi: true
    },
    provideAnimationsAsync(),
    provideToastr({
      timeOut: 3000,
      // closeButton: true,
      maxOpened: 1,
      autoDismiss: true,
      preventDuplicates: true,
      enableHtml: true  // Enable HTML rendering for formatted messages
    })
  ]
};
